<template>
    <div class="col-lg-12">
        <div class="card border-top-0">

            <div class="tab-content">
                <div class="tab-pane fade show active" id="profileTab" role="tabpanel">
                    <div class="card-body personal-info">
                        <form @submit.prevent="submitForm">
                            <div class="mb-4 d-flex align-items-center justify-content-between">
                                <h5 class="fw-bold mb-0 me-4">
                                    <span class="d-block mb-2">Kullanıcı Kartı:</span>
                                    <span class="fs-12 fw-normal text-muted text-truncate-1-line">Kullanıcı kartlarını
                                        buradan ekleyebilirsiniz.</span>
                                </h5>
                                <div class="d-flex gap-2">
                                    <button type="submit" class="btn btn-sm btn-light-brand">Kaydet</button>
                                    <a href="javascript:void(0);" class="btn btn-sm btn-light-brand">Kaydet ve Yeni
                                        Sayfa
                                        Aç</a>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Kullanıcı Adı: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="user.username"
                                            placeholder="Kullanıcı Adı">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Geçici Şifre: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="password" class="form-control" v-model="user.password"
                                            placeholder="Geçici Şifre">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">İsmi: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="user.first_name"
                                            placeholder="İsmi">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Soyismi: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="user.last_name"
                                            placeholder="Soyismi">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">E-Posta: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="user.email"
                                            placeholder="E-Posta">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Admin: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="form-check form-switch form-switch-lg">
                                        <input class="form-check-input c-pointer" type="checkbox" checked="true"
                                            v-model="user.is_superuser">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
export default {
    name: 'CreateUser',
    data() {
        return {
            user: {
                username: "",
                password: "",
                first_name: "",
                last_name: "",
                email: "",
                is_superuser: false,
                is_active: true,
            },
        }
    },
    async mounted() {
        // await this.fetchSpecies();
    },
    methods: {
        async submitForm() {
            try {
                const response = await this.$axios.post('user/', this.user, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                Swal.fire('Başarılı!', 'Kayıt tamamlandı.', 'success');
                this.$router.push({ name: 'Users', params: { page: 1 } });
            } catch (error) {
                console.log(error);

                let errorMessage = Object.entries(error.response.data)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br><br>');

                Swal.fire({
                    title: 'Hata!',
                    html: errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }
        },

    }
}
</script>